<template>
  <!-- 災害情報サマリ -->
  <div id="AppDisasterSummary">
    <!-- 余白 -->
    <div style="height: 10px" />

    <div class="columns">
      <div class="column">
        <label class="searchTitle label">災害情報サマリ</label>
      </div>
    </div>

    <!-- ボタン -->
    <div style="text-align: right">
      <b-button
        v-on:click="back()"
        class="button"
        type="is-primary"
        icon-left="keyboard-backspace"
        native-type="button"
      >
        戻る
      </b-button>
    </div>

    <!-- 件名 -->
    <div style="height: 10px" />
    <div style="text-align: left">
      <div style="display: flex">
        <div style="white-space: nowrap; flex-grow: 0; margin-right: 0.5rem">
          {{ period }}
        </div>
        <div :title="subject" class="text">{{ subject }}</div>
      </div>
    </div>
    <div style="height: 10px" />

    <!-- 一覧 -->
    <div>
      <b-table :data="summaryResult" ref="table" detailed custom-detail-row>
        <template slot-scope="props">
          <b-table-column
            field="areaName"
            :label="columnsVisible['areaName'].title"
            sortable
            centered
          >
            {{ props.row.areaName }}
          </b-table-column>

          <b-table-column
            field="blockName"
            :label="columnsVisible['blockName'].title"
            sortable
            centered
          >
            {{ props.row.blockName }}
          </b-table-column>

          <b-table-column
            field="branchName"
            :label="columnsVisible['branchName'].title"
            sortable
            centered
          >
            {{ props.row.branchName }}
          </b-table-column>

          <b-table-column
            field="salesOfficeName"
            :label="columnsVisible['salesOfficeName'].title"
            sortable
            centered
          >
            {{ props.row.salesOfficeName }}
          </b-table-column>

          <b-table-column
            field="patientNum"
            :label="columnsVisible['patientNum'].title"
            sortable
            centered
          >
            <div class="numerical">
              {{ props.row.patientNum }}
            </div>
          </b-table-column>

          <!-- 要連絡 -->
          <b-table-column
            field="contactStatusNoContactNum"
            :label="columnsVisible['contactStatusNoContactNum'].title"
            sortable
            centered
          >
            <div
              class="alignRightBox"
              :style="
                getNotCompletedBackStyle(
                  props.row,
                  getContactStatusRate(props.row, 'contactStatusNoContactNum', 'contactStatusAgainNum', 'patientNum'),
                  'patientNum'
              )"
            >
              <div class="alignRight">{{ Number(props.row.contactStatusNoContactNum) + Number(props.row.contactStatusAgainNum) }}</div>
            </div>
          </b-table-column>
          <b-table-column
            field="contactStatusAgainNum"
            :label="columnsVisible['contactStatusAgainNum'].title"
            sortable
            centered
          >
            <div class="numerical">
              {{ props.row.contactStatusAgainNum }}
            </div>
          </b-table-column>

          <!-- 連絡済 -->
          <b-table-column
            field="contactStatusCompletedNum"
            :label="columnsVisible['contactStatusCompletedNum'].title"
            sortable
            centered
          >
            <div
              class="alignRightBox"
              :style="getCompletedBackStyle(
                props.row,
                getContactStatusRate(props.row, 'contactStatusCompletedNum', 'supportStatusNeedServiceNum', 'patientNum'),
                'patientNum'
              )"
            >
              <div class="alignRight">{{ Number(props.row.contactStatusCompletedNum) }}</div>
              <div class="rateAlignRight">
                ({{ getContactStatusRate(props.row, "contactStatusCompletedNum", "supportStatusNeedServiceNum", "patientNum") }}%)
              </div>
            </div>
          </b-table-column>

          <!-- 要出動対応 -->
          <b-table-column
            field="supportStatusNeedServiceNum"
            :label="columnsVisible['supportStatusNeedServiceNum'].title"
            sortable
            centered
          >
            <div
              class="alignRightBox"
              :style="getNotCompletedBackStyle(props.row, 'supportStatusNeedServiceNum', 'contactStatusCompletedNum')"
            >
              <div class="alignRight">{{ props.row.supportStatusNeedServiceNum }}</div>
            </div>
          </b-table-column>

          <!-- 対応完了 -->
          <b-table-column
            field="supportStatusCompleted"
            :label="columnsVisible['supportStatusCompleted'].title"
            sortable
            centered
          >
            <div
              class="alignRightBox"
              :style="getCompletedBackStyle(props.row, getCompletedRate(props.row), 'patientNum')"
            >
              <div class="alignRight">{{ props.row.supportStatusCompleted }}</div>
              <div class="rateAlignRight">
                ({{ getCompletedRate(props.row) }}%)
              </div>
            </div>
          </b-table-column>
        </template>

        <!-- 詳細部 -->
        <template slot="detail" slot-scope="props">
          <tr
            v-for="detail in props.row.details"
            :key="detail.name"
            class="detailColor"
          >
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              <div class="branchName">
                {{ getItemCategoryName(detail) }}
              </div>
            </td>
            <td class="has-text-centered">
              <div class="numerical">
                {{ detail.patientNum }}
              </div>
            </td>
            <!-- ステータス -->
            <!-- 要連絡 -->
            <td>
              <div
                class="border"
                :style="getNotCompletedStyle(
                  detail,
                  getContactStatusRate(detail, 'contactStatusNoContactNum', 'contactStatusAgainNum', 'patientNum'),
                  'patientNum'
                )"
              >
                <div class="alignRight">{{ Number(detail.contactStatusNoContactNum) + Number(detail.contactStatusAgainNum) }}</div>
              </div>
            </td>
            <!-- 再架電 -->
            <td class="has-text-centered">
              <div class="numerical">
                {{ detail.contactStatusAgainNum }}
              </div>
            </td>
            <!-- 連絡済 -->
            <td class="has-text-centered">
              <div
                class="border"
                :style="getCompletedStyle(
                  detail,
                  getContactStatusRate(detail, 'contactStatusCompletedNum', 'supportStatusNeedServiceNum', 'patientNum'),
                  'patientNum'
                )"
              >
                <div class="alignRight">{{ Number(detail.contactStatusCompletedNum) }}</div>
                <div class="rateAlignRight">
                  ({{ getContactStatusRate(detail, "contactStatusCompletedNum", "supportStatusNeedServiceNum", "patientNum") }}%)
                </div>
              </div>
            </td>
            <!-- 対応状況 -->
            <!-- 要出動対応 -->
            <td>
              <div
                class="border"
                :style="getNotCompletedStyle(detail, 'supportStatusNeedServiceNum', 'contactStatusCompletedNum')"
              >
                <div class="alignRight">{{ detail.supportStatusNeedServiceNum }}</div>
              </div>
            </td>
            <!-- 対応完了 -->
            <td>
              <div
                class="border"
                :style="getCompletedStyle(detail, getCompletedRate(detail), 'patientNum')"
              >
                <div class="alignRight">{{ detail.supportStatusCompleted }}</div>
                <div class="rateAlignRight">
                  ({{ getCompletedRate(detail) }}%)
                </div>
              </div>
            </td>
          </tr>
        </template>
      </b-table>
    </div>

    <!-- 下部余白 -->
    <div style="height: 10px" />
  </div>
</template>

<script>
import * as patient from "../utils/patient";

export default {
  data() {
    return {
      columnsVisible: {
        areaName: { title: "エリア名" },
        blockName: { title: "ブロック名" },
        branchName: { title: "支店名" },
        salesOfficeName: { title: "営業所名" },
        patientNum: { title: "患者数" },
        contactStatusNoContactNum: { title: "要連絡" },
        contactStatusAgainNum: { title: "再架電" },
        contactStatusCompletedNum: { title: "連絡済" },
        supportStatusNeedServiceNum: { title: "要出動対応" },
        supportStatusCompleted: { title: "対応完了" },
      },
      summaryResult: [],
    };
  },

  computed: {
    // 期間
    period: function () {
      const disasters = this.$route.params.disasters;
      let createDateMin = disasters[0].createDate;
      let createDateMax = disasters[0].createDate;
      for (const disasterCode of disasters) {
        if (createDateMin > disasterCode.createDate) {
          createDateMin = disasterCode.createDate;
        }
        if (createDateMax < disasterCode.createDate) {
          createDateMax = disasterCode.createDate;
        }
      }
      const period = createDateMin == createDateMax ? 
        createDateMin : createDateMin + " ～ " + createDateMax;
      return period;
    },

    // 件名
    subject: function () {
      const disasters = this.$route.params.disasters;
      let _disaster = disasters[0];
      for (const disaster of disasters) {
        if (disaster.disasterId > _disaster.disasterId) {
          _disaster = disaster;
        }
      }
      return _disaster.disasterName;
    },
  },

  filters: {},

  methods: {
    // 戻る
    back: function () {
      this.doReturn();
    },
    doReturn: function () {
      this.$router.push({
        name: "AppDisasterSearch",
        params: { searchConditions: this.$route.params.searchConditions },
      });
    },
    // %を求める式
    getContactStatusRate: function (data, numeratorName1, numeratorName2, denominatorName) {
      let rate = 0;
      if (data[denominatorName]) {
        rate = Math.round(
          ((Number(data[numeratorName1]) + Number(data[numeratorName2])) / data[denominatorName]) * 100
        );
      }
      return isFinite(rate) ? rate : 0;
    },
    getCompletedRate: function (data) {
      let rate = 0;
      if (data.patientNum) {
        rate = Math.round(
          (data.supportStatusCompleted / data.patientNum) * 100
        );
      }
      return isFinite(rate) ? rate : 0;
    },
    // 要連絡、要出動対応 背景色
    getNotCompletedBackStyle: function (data, rate, denominatorName) {
      if (rate == 0 || data[denominatorName] == 0) {
        return "background-color: #209CEE; color: white; border-radius: 5px;";
      } else if (rate < 50) {
        return "background-color: #FFDD57; color: black; border-radius: 5px;";
      } else {
        return "background-color: #FF3860; color: white; border-radius: 5px;";
      }
    },
    // 連絡済、対応完了 背景色
    getCompletedBackStyle: function (data, rate, denominatorName) {
      if (rate == 100 || data[denominatorName] == 0) {
        return "background-color: #209CEE; color: white; border-radius: 5px;";
      } else if (rate >= 50) {
        return "background-color: #FFDD57; color: black; border-radius: 5px;";
      } else {
        return "background-color: #FF3860; color: white; border-radius: 5px;";
      }
    },
    // 要連絡、要出動対応 文字色
    getNotCompletedStyle: function (data, rate, denominatorName) {
      if (rate == 0 || data[denominatorName] == 0 || rate < 50) {
        return "background-color: white; color: black;";
      } else {
        return "background-color: white; color: red;";
      }
    },
    // 連絡済、対応完了 文字色
    getCompletedStyle: function (data, rate, denominatorName) {
      if (rate == 100 || data[denominatorName] == 0 || rate >= 50) {
        return "background-color: white; color: black;";
      } else {
        return "background-color: white; color: red;";
      }
    },

    getSummaryPOST: function (client) {
      // パラメータ準備
      const disasterIdList = [];
      const disasters = this.$route.params.disasters;
      for (const row of disasters) {
        disasterIdList.push(row.disasterId);
      }
      //　サマリ取得API実行
      const apiRes = client.apis.apiDisaster.getSummaryPOST({
        body: {
          disasterIdList: disasterIdList,
        },
      });
      return apiRes;
    },

    getSummaryPOSTSucces: function (result) {
      this.summaryResult = result.obj;
      return;
    },

    getSummaryPOSTError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      return;
    },

    getItemCategoryName: function (detail) {
      const itemCategory = patient.THERAPY_TYPE_SUMMARY_STATUSES.find((elem) => elem.code == detail.itemCategory);
      return itemCategory.name + "：";
    }
  },

  created: function () {
    // サマリ取得
    this.apiCall(
      this.getSummaryPOST,
      this.getSummaryPOSTSucces,
      this.getSummaryPOSTError
    );
  },
};
</script>

<style scoped>
.text {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 1;
}

.border {
  border: solid 1.5px;
  border-radius: 5px;
  border-color: black;
  margin: 0 auto;
  display: flex;
}

.alignRightBox {
  margin: 0 auto;
  display: flex;
}

.alignRight {
  width: 75%;
  text-align: right;
  margin-left: 10px;
}

.rateAlignRight {
  width: 20%;
  text-align: right;
  min-width: 40px;
  margin-right: 10px;
}

.detailColor {
  background: #d4eaff;
}

.detailColor:hover {
  background-color: #f7f8f9;
}

.numerical {
  margin: 0 auto;
  text-align: right;
}

.branchName {
  width: calc(50%);
  margin: 0 auto;
  text-align: start;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/AppDisasterSummary.vue